import { Namespace, useT } from "@racoon/i18n";
import { IcChat } from "@racoon/icons";
import { Button } from "@racoon/ui";
import { useEffect } from "react";
import { useGetChatsQuery } from "~/shared/api/chat/chat.api";

export const ChatListSidebar = ({
  activeChatId,
  setActiveChatId,
}: {
  activeChatId: string | null;
  setActiveChatId: (chatId: string | null) => void;
}) => {
  const t = useT();
  const { data: chats = [], isSuccess } = useGetChatsQuery();

  useEffect(() => {
    if (isSuccess && chats.length > 0) {
      setActiveChatId(chats[0].id);
    }
  }, [chats, isSuccess]);

  return (
    <div className="w-full bg-white dark:bg-slate-950 rounded-xl space-y-2">
      <div className="flex gap-2 items-center mb-4">
        <IcChat width={24} height={24} className="text-brand-blue" />
        <span className="text-black font-medium">{t(Namespace.Chat, "chat")}</span>
      </div>
      <Button
        id="chat-list-add-chat-button"
        disabled={activeChatId === null}
        variant="opacityBlueWithOutline"
        className="w-full"
        onClick={() => setActiveChatId(null)} // Start a new chat
      >
        {t(Namespace.Chat, "addChat")}
      </Button>
      <div>
        {chats.map((chat) => (
          <div
            key={chat.id}
            className={`p-2 cursor-pointer font-normal hover:bg-secondary rounded-lg ${activeChatId === chat.id ? "bg-brand-blue text-text-invert " : ""}`}
            onClick={() => setActiveChatId(chat.id)}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {chat.title || `Chat ${chat.id}`}
          </div>
        ))}
      </div>
    </div>
  );
};
